export const MAIN_MARKETPLACE_LISTING_URL = 'https://mypropertymarketplace.co.uk/listing';

const MS_PER_SECOND = 1000;

export const CLOSING_REDIRECT_SECONDS = 10;
export const CLOSING_REDIRECT_DELAY_MS = CLOSING_REDIRECT_SECONDS * MS_PER_SECOND;
